import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { SelectComponent } from '@ftr/forms'
import { AnchorComponent, BreadcrumbModule, ButtonComponent, IconComponent, TooltipModule } from '@ftr/foundation'

/*
 * FTR Web App Imports
 */
import { DropdownMenuLegacyComponent } from '@ftr/menus'
import { SideNavModule } from '@ftr/ui-core'
import { LegacyOverflowMenuComponent } from '~app/shared/overflow-menu/legacy-overflow-menu.component'

/*
 * FTR Admin App Imports
 */
import { FtrLogoComponent, HeaderLoggedOutComponent } from '@ftr/ui-core'
import { CourtSystemLogoComponent } from '@ftr/ui-court-system'
import { AccountMenuComponent } from '~admin/app/core/header/account-menu/account-menu.component'
import { HeaderComponent } from '~admin/app/core/header/header.component'

@NgModule({
  imports: [
    AnchorComponent,
    ButtonComponent,
    CommonModule,
    CourtSystemLogoComponent,
    DropdownMenuLegacyComponent,
    FtrLogoComponent,
    IconComponent,
    LegacyOverflowMenuComponent,
    RouterModule,
    SelectComponent,
    SideNavModule,
    TooltipModule,
    HeaderLoggedOutComponent,
    BreadcrumbModule,
  ],
  declarations: [AccountMenuComponent, HeaderComponent],
  exports: [HeaderComponent, AccountMenuComponent],
})
export class HeaderModule {}
